import {
  modifyPartnerCampaign,
  receivePartnerCampaign,
  setPartnerCampaignIsBusy,
  closePartnerCampaign,
  setPartnerCampaignHasValidationError
} from './partner-campaign.actions';
import itemReducer from '../../../items/item.reducers';

const partnerCampaignReducer = itemReducer(
  receivePartnerCampaign,
  setPartnerCampaignIsBusy,
  modifyPartnerCampaign,
  closePartnerCampaign,
  undefined,
  setPartnerCampaignHasValidationError
);

export default partnerCampaignReducer;
